module.exports = __webpack_public_path__ + "img/lungs.9c91ca06.svg";